import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";

import { useStyles } from "./SchoolHeader.css";
import { publicImageUrl } from "../../../Config/publicImageUrl";
import Axios from "axios";
import { url } from "../../../Config/Config";

class SchoolHeader extends Component {
  constructor(props) {
    super(props);
    this.state = { schoolDetails: {} };
  }

  componentDidMount() {
    this.getSchoolDetails();
  }

  getSchoolDetails = async () => {
    const response = await Axios.get(`${url}/api/setting`);
    if (response.data) {
      this.setState({ schoolDetails: response.data });
    }
  };

  render() {
    const { classes, studentDetails } = this.props;
    const { schoolDetails } = this.state;
    return (
      <div>
        <div className={classes.feeRoot}>
          <div style={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
            {schoolDetails.schoolLogo && (
              <img
                src={`${publicImageUrl}/${schoolDetails.schoolLogo}`}
                alt={schoolDetails.schoolName}
                style={{ width: 100, height: 100 }}
              />
            )}
            <div>
              <div>{schoolDetails.schoolName}</div>
              <div>{schoolDetails.address}</div>
            </div>
          </div>
          <div style={{ textAlign: "center" }}>
            <div>
              +977-{schoolDetails.mobileNumber},{schoolDetails.landLineNumber}
            </div>
            <div>{schoolDetails.email}</div>
          </div>
        </div>
        <div
          className={classes.tableStyle}
          style={{ paddingTop: 20, paddingBottom: 20 }}
        >
          {this.props.examType && (
            <div
              style={{ textAlign: "center", fontSize: 18, fontWeight: "bold" }}
            >
              {this.props.examType}
            </div>
          )}
          <div className={classes.listitemRoot}>
            <ListItem>
              <b style={{ flexGrow: 1 }}>Name:</b>
              <div>
                {studentDetails.firstName} {studentDetails.lastName}
              </div>
            </ListItem>
            <ListItem>
              <b style={{ flexGrow: 1 }}>Class :</b>
              <div>
                <div>{studentDetails.studentClass} </div>
                {studentDetails.faculty && (
                  <div> - {studentDetails.faculty}</div>
                )}
                {studentDetails.group && <div> - {studentDetails.group}</div>}
              </div>
            </ListItem>
          </div>
          <div className={classes.listitemRoot}>
            <ListItem>
              <b style={{ flexGrow: 1 }}>Section :</b>
              <div>{studentDetails.section}</div>
            </ListItem>
            {this.props.month && (
              <ListItem>
                <b style={{ flexGrow: 1 }}> Month :</b>
                <div>{this.props.month}</div>
              </ListItem>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(SchoolHeader);
